// @flow
import * as React from 'react';
import classnames from 'classnames';

import { BOOKING_PAYMENT_STATUS_VALIDATED } from 'Utils/booking-payment-status/bookingPaymentStatus.constants';
import ReactAppContext from 'Context/ReactAppContext';
import { ICONS } from 'Components/utils/icon/icons';
import { COLORS } from 'Components/utils/color/colors';

import { Button } from 'Components/frameworks/button/Button.jsx';
import { Icon } from 'Components/frameworks/icon/Icon.jsx';

type CTA = {
  label: string,
  url: string,
};

type Props = {
  className?: string,
  dataSelector?: string,
  isBookingPaid: boolean,
  shouldProposeOnlinePayment: boolean,
  status: BookingStatus,
  +bookingPaidLabel?: string,
  +bookingStatusLink?: CTA,
  children?: React.Node,
  onClick?: () => mixed,
};

const defaultProps = {
  dataSelector: 'BookingPaymentStatus',
};

function BookingPaymentStatus({
  className,
  dataSelector,
  isBookingPaid,
  shouldProposeOnlinePayment,
  status,
  bookingPaidLabel,
  bookingStatusLink,
  children,
  onClick,
}: Props) {
  const app = React.useContext(ReactAppContext);
  const isBookingValidated = status === BOOKING_PAYMENT_STATUS_VALIDATED;

  if (isBookingPaid && isBookingValidated) {
    return (
      <div className={classnames('BookingPaymentStatus', className)} data-selector={dataSelector}>
        <p className="flex items-center">
          <span className="BookingPaymentStatus--payed">{bookingPaidLabel}</span>
          <Icon
            className="bg-emerald p-2 rounded-half"
            color={COLORS.WHITE}
            name={ICONS.CHECK}
            width="1.875rem"
          />
        </p>
      </div>
    );
  }

  if (!shouldProposeOnlinePayment || !app.canUseOnlinePayment) {
    return null;
  }

  if (bookingStatusLink) {
    return (
      <div className={classnames('BookingPaymentStatus', className)} data-selector={dataSelector}>
        <Button
          dataSelector={`${String(dataSelector)}-button`}
          url={bookingStatusLink.url}
          colorBg={COLORS.BOOKING}
          colorBorder={COLORS.BOOKING}
          onClick={onClick}
          dataTestId={`${String(dataSelector)}--button`}
        >
          {bookingStatusLink.label}
        </Button>
      </div>
    );
  }

  if (children) {
    return (
      <div className={classnames('BookingPaymentStatus', className)} data-selector={dataSelector}>
        {children}
      </div>
    );
  }

  return null;
}

BookingPaymentStatus.defaultProps = defaultProps;

export default BookingPaymentStatus;
